export default __webpack_public_path__ + "static/media/bb.68defd9f.jpg";